export const useFormatDate = (date: Date) => {
	if (date !== null) {
		const formattedDate = new Intl.DateTimeFormat('en-GB').format(date);
		const finalDate = formattedDate.split('/').reverse().join('-');
		return finalDate;
	}
	return null;
};
